import * as PIXI from 'pixi.js';

export function createDesaturationFilter(strength: number): PIXI.ColorMatrixFilter {
  const filter = new PIXI.ColorMatrixFilter();
  // In PixiJS v8, use saturate() instead of desaturate()
  // strength 0.45 (45% desaturation) = 55% saturation remaining = saturate(0.55)
  filter.saturate(1.0 - strength, false);
  return filter;
}

export function applyDesaturation(
  container: PIXI.Container,
  strength: number
): void {
  if (!container || strength < 0 || strength > 1) return;

  // Check for existing filter
  const existing = container.filters?.find(
    f => f instanceof PIXI.ColorMatrixFilter
  ) as PIXI.ColorMatrixFilter | undefined;

  if (existing) {
    // In PixiJS v8, use saturate() instead of desaturate()
    existing.saturate(1.0 - strength, false);
  } else {
    const filter = createDesaturationFilter(strength);
    container.filters = [...(container.filters || []), filter];
  }
}

export function removeDesaturation(container: PIXI.Container): void {
  if (!container) return;
  if (!container.filters) return;
  container.filters = container.filters.filter(
    f => !(f instanceof PIXI.ColorMatrixFilter)
  );
  if (container.filters.length === 0) container.filters = null;
}
